import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { Mode, ReserveResponse } from 'src/app/components/consulting-reservation/consulting-reservation.types';

@Injectable({
  providedIn: 'root'
})
export class ConsultingReservationService {
  readonly #http = inject(HttpClient);
  readonly #location = inject(Location);

  next(mode: Mode) {
    this.#location.go(window.location.pathname, `step=${mode}`);
  }

  replace() {
    const params = new URLSearchParams(window.location.search);
    params.set('step', 'step1');
    this.#location.replaceState(window.location.pathname, params.toString());
  }

  reserve(data: unknown): Observable<ReserveResponse | null> {
    const reservedAt = localStorage.getItem('reservedAt');
    if (reservedAt) {
      const diff = Math.abs(new Date().getTime() - Number(reservedAt));
      if (diff <= 24 * 60 * 60 * 1000) {
        alert('既にお申込みがあります。\n\nご予約内容（お名前やメールアドレス）に不備があった場合や、カウンセリング日時の確認・変更をご希望の場合は、夢カナ留学の下記電話番号までお問い合わせください。\n\n03-5050-0802');
        return of(null);
      }
    }

    const prize = sessionStorage.getItem('prize');
    if (prize !== null) {
      (data as any).prize = Number(prize.replace(/[^0-9]/g, ""));
    }

    return this.#http.post<ReserveResponse>('api/reservations', data)
      .pipe(
        tap(res => {
          localStorage.setItem('reservedAt', new Date().getTime().toString());
        })
      );
  }

  back() {
    this.#location.back();
  }
}
